import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "harrys-wand",
  name: `Wand - Harry Potter`,
  origin: "Harry Potter and the Prisoner of Azkaban",

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
